import { LogIn } from 'lucide-react';

import type { AuthOptions } from 'src/shared/lib/auth.utils';
import { Button } from 'src/shared/components/ui/buttons/button';
import { identityProviders } from 'src/shared/constants/uiConfig.constant';

type AuthMethod = AuthOptions['authMethods'][number];

export function getSortedSsoMethods(methods: AuthMethod[]): AuthMethod[] {
  return methods
    .filter((method) => method.type === 'SSO')
    .slice()
    .sort((a, b) => (a.identityProvider ? -1 : 1) - (b.identityProvider ? -1 : 1));
}

type SsoMethodButtonsProps = {
  methods: AuthMethod[];
  getLabel: (name: string) => string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>, method: AuthMethod) => void;
};

export function SsoMethodButtons({ methods, getLabel, onClick }: SsoMethodButtonsProps) {
  const ssoMethods = getSortedSsoMethods(methods);

  return (
    <>
      {ssoMethods.map((method) => {
        const identityProvider = method.identityProvider;
        const ipdConfig =
          identityProvider && identityProvider in identityProviders
            ? identityProviders[identityProvider as keyof typeof identityProviders]
            : null;
        const name = ipdConfig?.shortLabel || method?.name || 'SSO';
        const image = ipdConfig?.image;

        return (
          <Button
            key={method.id}
            className="w-full relative px-12"
            variant="outline"
            onClick={(e) => onClick(e, method)}
          >
            {image ? (
              <img
                src={image}
                width={18}
                height={18}
                alt={name}
                className="absolute left-2.5 top-1/2 -translate-y-1/2"
              />
            ) : (
              <div className="flex items-center justify-center absolute left-2.5 top-1/2 -translate-y-1/2">
                <LogIn size={18} className="text-neutral-400" />
              </div>
            )}
            <p className="truncate">{getLabel(name)}</p>
          </Button>
        );
      })}
    </>
  );
}
